module.exports = __webpack_public_path__ + "static/media/ramnandan.88cb4f79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/prelogin/public/img/testimonial/ramnandan.jpg
// module id = 1279
// module chunks = 0